// https://dev.to/barrymichaeldoyle/how-to-build-a-custom-react-hook-to-listen-for-keyboard-events-32b4
import { useEffect } from "react";

interface UseKeyboardShortcutArgs {
    key: string
    onKeyPressed: () => void;
    onKeyUp: () => void;
}

export function useKeyboardShortcut({
    key,
    onKeyPressed,
    onKeyUp
}: UseKeyboardShortcutArgs) {
    useEffect(() => {
        function keyDownHandler(e: globalThis.KeyboardEvent) {
            if (e.key === key) {
                e.preventDefault();
                onKeyPressed();
            }
        }
        function keyUpHandler(e: globalThis.KeyboardEvent) {
            if (e.key === key) {
                e.preventDefault();
                onKeyUp();
            }
        }

        document.addEventListener("keydown", keyDownHandler);
        document.addEventListener("keyup", keyUpHandler);

        return () => {
            document.removeEventListener("keydown", keyDownHandler);
            document.removeEventListener("keyup", keyUpHandler);
        }
    }, [key, onKeyPressed, onKeyUp]);
}